import type { ButtonProps, NavButtonProps } from "./nav-button.type";

import { Button } from "antd";
import classNames from "classnames";

import ButtonLink from "@/modules/button-link";

import "./nav-button.style.less";

export const NavButton = ({ link, className, ...props }: NavButtonProps) => {
  const buttonProps: ButtonProps = {
    type: "text",
    shape: "circle",
    className: classNames("nav-button", className),
    ...props,
  };

  if (link) return <ButtonLink {...buttonProps} {...link} />;

  return <Button {...buttonProps} />;
};
